import React from "react"
import styled from "@emotion/styled"
import { connect } from "react-redux";

const Main = ({content, navOn, dispatch}) => {
	let navClass = 'navOff';
	if (navOn === null) {
		navClass = 'navInit';
	} else if (navOn) {
		navClass = 'navOn';
	}
	return (
		<Wrapper className={navClass}>
			{ content }
		</Wrapper>
	);
}

export default connect(state => ({
  navOn : state.navOn
}))(Main);

const Wrapper = styled("div")`
	position: absolute;
	top: 0;
	left: 0;
	width:100%;
	.section {
		padding: 10px !important;
		float: left;
		width: 100%;
		box-sizing: border-box;
		overflow: hidden;
		@media screen and (max-width: 600px) {
			padding: 10px 5px !important;
		}
		&.hasAd {
			padding: 0 10px !important;
			@media screen and (max-width: 600px) {
				padding: 0 !important;
			}
		}
		.section_inner {
			max-width: 970px;
			@media screen and (min-width: 1000px) {
				margin: 0 auto;
			}
			@media screen and (min-width: 1415px) {
				/* margin: 0 345px 0 35px; */
				margin: 0 320px 0 0;
				max-width: none;
			}
		}
	}
	&.navOn .section, &.navInit .section {
		padding: 10px 10px 10px 140px !important;
		@media screen and (max-width: 600px) {
			padding: 10px 5px !important;
		}
	}
	.divider_section {
	  background: rgb(96, 184, 195)
	}
`
